import { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Blog from './pages/Blog'
import Contact from './pages/Contact'
import Products from './pages/Products'
import Nav from './pages/Nav'
import Footer from './pages/Footer'
import ScrollToTop from './pages/ScrollToTop'
import { ScrollProgress } from './components/Motion'

// React Router keeps the scroll position across navigations; reset it so each
// page opens at the top.
const ScrollReset = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])
  return null
}

function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollReset />
      <ScrollProgress />
      <Nav />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<Products />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      <ScrollToTop />
      <Footer />
    </div>
  )
}

export default App
